import {
  AppBar,
  IconButton,
  Stack,
  Toolbar,
  Typography,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useNavigate } from "react-router-dom";
import theme from "../theme/theme";
import i18n from "../i18n-config";
import React, {  } from "react";
import CustomButton from "./CustomButton";
import SvgContainer from "./SvgContainer";
import { ADD, MESSAGE, NOTIFICATION } from "../assets/icons";
import CustomSearchBar from "./CustomSearchBar";
import CustomAvatar from "./CustomAvatar";
import { capitalizeFirstLetter } from "../utils/strings";

const drawerWidth = 250;

const useStyles = makeStyles((theme: any) => ({
  appBar: {
    backgroundColor: "#fff",
    boxShadow: "none",
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
}));

export default function CustomAppBar({
  mobileOpen,
  user,
}: any) {
  const classes = useStyles();
  const navigate = useNavigate();  

  const goToCreateBara = () => {
    navigate("/bara/bara-form");
  };

  const goToNotification = () => {
    navigate("/notifications");
  };

  const goToProfile = () => {
    navigate("/parametres/profile");
  };

  return (
    <React.Fragment>
      <AppBar
        position="fixed"
        className={classes.appBar}
        sx={{
          marginLeft: drawerWidth,
          width: mobileOpen ? `calc(100% - ${drawerWidth}px)` : "100%",
        }}
      >
        <Toolbar style={{ justifyContent: "space-between" }}>
          <Stack direction={"row"} alignItems="center" sx={{ width: "70%" }}>
          
            <CustomSearchBar placeholder={capitalizeFirstLetter(i18n.t("rechercher"))} />
            <CustomButton
              title={i18n.t("creer_bara")}
              leftComponent={
                <SvgContainer svg={ADD} color={theme.colors.white} width={15} />
              }
              titleStyle={{ marginLeft: 1 }}
              onClick={goToCreateBara}
            />
          </Stack>

          <Stack
            direction={"row"}
            alignItems="center"
            justifyContent={"flex-end"}
            spacing={2}
            sx={{ width: "30%" }}
          >
            <IconButton
              sx={{
                backgroundColor: "#F8F8F8",
                borderRadius: 100,
                width: 42,
                height: 42,
              }}
              onClick={goToNotification}
            >
              <SvgContainer
                svg={NOTIFICATION}
                color={theme.colors.dimgray}
                width={15}
              />
            </IconButton>

            <IconButton
              sx={{
                backgroundColor: "#F8F8F8",
                borderRadius: 100,
                width: 42,
                height: 42,
              }}
            >
              <SvgContainer
                svg={MESSAGE}
                color={theme.colors.dimgray}
                width={19}
              />
            </IconButton>

            <IconButton sx={{ borderRadius: 2 }} onClick={goToProfile}>
              <Stack
                direction="row"
                sx={{
                  alignItems: "center",
                }}
              >
                <Typography
                  sx={{
                    color: theme.colors.black,
                    fontSize: 13,
                    textTransform: "capitalize",
                    fontWeight: 600,
                  }}
                  mr={1}
                >
                  {user.nom}
                </Typography>
                <CustomAvatar
                    rootStyle={{
                      border: "none",
                      marginTop: 0,
                      marginLeft: 0,
                    }}
                    avatarStyle={{ borderRadius: 100 }}
                  />
              </Stack>
            </IconButton>
          </Stack>
        </Toolbar>
      </AppBar>
      {/* <CustomDialog
        isVisible={showConfirm}
        title={capitalizeFirstLetter(i18n.t("logout"))}
        message={capitalizeFirstLetter(i18n.t("want_to_disconnect"))}
        onCancel={() => setShowConfirm(false)}
        okDisabled={disabled}
        onOk={signout}
        cancelTitle={i18n.t("no")}
        okTitle={i18n.t("yes")}
      /> */}
    </React.Fragment>
  );
}
